import { Injectable, Output, EventEmitter } from '@angular/core';
import API from '../../common/services/api.config.json';
import { TaskSaveModel } from '../entities/TaskSaveModel';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import { ApiService } from '../../common/services/api.service';
import { map, filter } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Tarea } from 'app/modules/task/entities/Tarea';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from 'app/modules/common/services/shared-service';
import moment from 'moment';
import Utils from 'app/Utils';

type TaskFeatureAdder = (task: Tarea) => void;

@Injectable()
export class TaskSaveService {
    public BajaId: number;
    private Subcription: Subscription;
    private tasksSubject = new BehaviorSubject(null);

    public tasks: Array<Tarea>;
    public IsLoading: boolean;
    public tasksColumns: any[];
    @Output() saved: EventEmitter<void> = new EventEmitter();
    @Output() savedTaskSelection: EventEmitter<void> = new EventEmitter();
    @Output() refershTabList: EventEmitter<void> = new EventEmitter();

    isPermitChangeTime = false;
    isPermitPrint = false;
    isPermitDeleteTask = false;

    constructor(
        public apiService: ApiService,
        public snackBar: MatSnackBar,
        public datePipe: DatePipe,
        public router: Router,
        public employeeStoreService: EmployeeStoreService,
        private sharedService: SharedService
    ) {}

    public SaveTask(saveTaskModel: TaskSaveModel): Observable<RestResponse> {
        const url = `${API.Task.saveTask}`;
        return this.apiService.post(url, saveTaskModel);
    }

    public changeTaskDate(model: any): Observable<RestResponse> {
        const url = `${API.Task.ChangeTaskDate}`;
        return this.apiService.post(url, model);
    }

    public changeTime(model: any): Observable<RestResponse> {
        const url = `${API.Task.changeTaskTime}`;
        return this.apiService.put(url, model);
    }

    public getEmpresaTieneSME(
        leaveId: number,
        employeeId
    ): Observable<RestResponse> {
        let url = `${API.Task.getEmpresaTieneSME}`;
        url += '?leaveId=' + leaveId + '&employeeId=' + employeeId;
        return this.apiService.get(url);
    }

    public getDefTareaForTaskDropdown(
        leaveId: number,
        employeeId: number
    ): Observable<RestResponse> {
        let url = `${API.Task.getDefTareaForTaskDropdown}`;
        url = url
            .replace('{leaveId}', leaveId.toString())
            .replace('{employeeId}', employeeId.toString());
        return this.apiService.get(url);
    }

    public getTaskTypesForCompany(companyId: number): Observable<RestResponse> {

        let url = `${API.Task.getDefTareaForTaskDropdown}`;
        url = url
            .replace('{leaveId}', "0")
            .replace('{employeeId}', "0");
        return this.apiService.get(url);
    }

    public getAuthComponentModel(
        leaveId: number,
        employeeId: number
    ): Observable<RestResponse> {
        let url = `${API.Task.getAuthComponentModel}`;
        url += '?leaveId=' + leaveId + '&employeeId=' + employeeId;
        return this.apiService.get(url);
    }

    public getAuthComponentModelForCompany(
        companyId: number
    ): Observable<RestResponse> {
        const url = `${API.Task.getAuthComponentModel}?companyId=${companyId}`;
        return this.apiService.get(url);
    }

    public GetTasks(bajaId: number): Observable<RestResponse> {
        this.IsLoading = true;
        this.BajaId = bajaId ? bajaId : 0;
        let url = `${API.Task.getTaresForBaja}`;
        url = url.replace('{bajaId}', this.BajaId.toString());
        return this.apiService.get(url);
    }

    public PublishTasks(leaveId: number): void {
        this.GetTasks(leaveId).subscribe(
            (resp) => {
                this.tasksSubject.next(resp.result);
            },
            (err) => {
                console.error(err);
            }
        );
    }

    public SubcribeTasks(): any {
        this.Subcription = this.tasksSubject
            .asObservable()
            .pipe(
                filter((val) => val !== null),
                map((array) => {
                    return array.map((elem) => {
                        let tooltiptext: string = null;
                        if (
                            elem.fReclamacion !== undefined &&
                            elem.fReclamacion !== null &&
                            elem.fReclamacion !== ''
                        ) {
                            const formattedDate = this.datePipe.transform(
                                new Date(elem.fReclamacion),
                                'dd/MM/yyyy hh:mm'
                            );
                            tooltiptext = `${formattedDate}`;
                        }

                        tooltiptext += elem.reclEmail
                            ? ` Email:${elem.reclEmail}`
                            : '';
                        tooltiptext += elem.reclTelefonica
                            ? ` Telefónica:${elem.reclTelefonica}`
                            : '';

                        return new Tarea(
                            elem.tareaId,
                            elem.tarea,
                            elem.comentario,
                            elem.reclEmail,
                            elem.reclTelefonica,
                            elem.fecha,
                            elem.hora,
                            elem.fReclamacion,
                            elem.autor,
                            elem.medico,
                            tooltiptext,
                            elem.icon,
                            elem.tipo,
                            elem.fechaRegistro,
                            elem.usuario
                        );
                    });
                })
            )
            .subscribe(
                (result) => {
                    this.tasks = result;
                    this.addComputedFields(this.tasks, [
                        this.computeRegistroHint,
                    ]);
                    this.IsLoading = false;
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    public GetTasksForSelection(
        companyId: string,
        doctorId: string,
        fromDate: string,
        toDate: string
    ): Observable<RestResponse> {
        let url = `${API.Task.getTaskSelection}?CompanyId=${companyId}&DoctorId=${doctorId}`;
        if (fromDate !== null) {
            url = url + `&From=${fromDate}`;
        }
        if (toDate !== null) {
            url = url + `&To=${toDate}`;
        }
        return this.apiService.get(url);
    }

    public GetTaskSelectionFilteredList(
        TaskFilter: any
    ): Observable<RestResponse> {
        const url = `${API.Task.TaskSelectionFilter}`;
        return this.apiService.post(url, TaskFilter);
    }

    public PrintTaskDocument(taskId: string): Observable<RestResponse> {
        let url = `${API.Task.printTaskDocument}`;
        url = url.replace('{taskId}', taskId);
        return this.apiService.get(url);
    }

    public PrintLopdDocument(trabajadorId: string): Observable<RestResponse> {
        let url = `${API.Task.printLopdDocument}`;
        url = url.replace('{employeeId}', trabajadorId);
        return this.apiService.get(url);
    }

    public Unsubscribe(): void {
        this.Subcription.unsubscribe();
    }

    GoToEmployee(trabajadorId): void {
        this.getEmployee(trabajadorId).subscribe((res) => {
            localStorage.setItem('EmplooyeeID', trabajadorId);
            const url =
                window.location.protocol +
                '//' +
                window.location.host +
                '/#/employee';
            window.open(url);
        });
    }

    getEmployee(employeeId: any): Observable<RestResponse> {
        return this.GetTrabDetail(employeeId).pipe(
            map((res) => {
                const employee = res.result;
                this.employeeStoreService.employee = employee;
                return res;
            })
        );
    }

    // This is a duplicate method. from employee Service. Have to find a better solution in furture.
    public GetTrabDetail(employeeId: number): Observable<RestResponse> {
        let url = `${API.Trabajador.getTrabajador}`;
        url = url.replace('{trabajadorId}', employeeId.toString());
        return this.apiService.get(url);
    }

    GoToPedirCita(trabajadorId: string, bajaId: number): void{
        this.getEmployee(trabajadorId).subscribe((res) => {
            localStorage.setItem('EmplooyeeID', trabajadorId);
            const url =
                window.location.protocol +
                '//' +
                window.location.host +
                '/#/employee/pedir-cita/' + bajaId;
            window.open(url);
        });
    }

    PrintDocument(task): void {
        this.PrintTaskDocument(task.tareaId).subscribe(
            (res) => {
                if (res.code === 0) {
                    const file = res.result.file;
                    const fileName = res.result.fileName;
                    const link = document.createElement('a');
                    link.setAttribute('type', 'hidden');
                    link.href = 'data:application/octet-stream;base64,' + file;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    this.sharedService.ShowSnackBar(
                        'No se ha podido descargar el documento',
                        '',
                        2500
                    );
                }
            },
            (err) => {
                this.sharedService.ShowSnackBar(
                    'No se ha podido descargar el documento',
                    '',
                    2500
                );
                console.error(err);
            }
        );
    }

    OnPrintLOPDDocument(task): void {
        this.PrintLopdDocument(task.trabajadorId).subscribe(
            (res) => {
                if (res.code === 0) {
                    const file = res.result.file;
                    const fileName = res.result.fileName;
                    const link = document.createElement('a');
                    link.setAttribute('type', 'hidden');
                    link.href = 'data:application/octet-stream;base64,' + file;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    this.sharedService.ShowSnackBar(
                        'No se ha podido descargar el documento',
                        '',
                        2500
                    );
                }
            },
            (err) => {
                this.sharedService.ShowSnackBar(
                    'No se ha podido descargar el documento',
                    '',
                    2500
                );
                console.error(err);
            }
        );
    }

    public deleteTask(taskId: string): Observable<RestResponse> {
        let url = `${API.Task.deleteTask}`;
        url = url.replace('{taskId}', taskId);
        return this.apiService.delete(url);
    }

    public validateAddNewTask(bajaId: string): Observable<RestResponse> {
        let url = `${API.Task.validateAddNewTask}`;
        url = url.replace('{bajaId}', bajaId);
        return this.apiService.get(url);
    }

    GetActiveUsers(): Observable<RestResponse> {
        const url = `${API.auth.getActiveUsers}`;
        return this.apiService.get(url);
    }

    GetUsersAbreviacion(): Observable<RestResponse> {
        const url = `${API.auth.getActiveAbreviacion}`;
        return this.apiService.get(url);
    }

    GetActiveCoordinator(): Observable<RestResponse> {
        const url = `${API.Coordinator.getActiveCoordinator}`;
        return this.apiService.get(url);
    }

    setPermissionForContextMenu(): void {
        const permissions: Array<string> = Utils.decrypt(localStorage
            .getItem('permissionIds'))
            .split(',');
        if (permissions.includes('625')) {
            this.isPermitPrint = true;
        }
        if (permissions.includes('626')) {
            this.isPermitChangeTime = true;
        }
        if (permissions.includes('617')) {
            this.isPermitDeleteTask = true;
        }
    }

    validateMarkedTask(tipo: number): boolean {
        return tipo > 30000 && tipo < 31999;
    }

    /**
     * Add computed field to tasks
     */
    private addComputedFields(
        tasks: Tarea[],
        featureAdders: TaskFeatureAdder[]
    ) {
        tasks.forEach((actuation) => {
            featureAdders.forEach((adder) => {
                adder(actuation);
            });
        });
    }

    /**
     * Compter registor hint display value. Add registroHint to the task
     */
    private computeRegistroHint(task: Tarea) {
        let hintText = '';

        if (task.usuario) hintText += task.usuario;

        if (task.fechaRegistro) {
            if (hintText) hintText += ' - ';

            const fRegistro = moment(task.fechaRegistro);
            hintText += fRegistro.format('DD/MM/YYYY HH:mm');
        }

        if (hintText) hintText = 'Registro: ' + hintText;

        task.registroHint = hintText;
    }
}
